var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 273.9 393.4",
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.2,37.1c9.8,1.9,19,6.2,27.6,13c12.9,11.3,20.6,24.6,23,39.9v79.8H34.7C14,174.5,2.5,186,0.2,204.2                           L0,357.9c2.3,21.9,14.2,33.8,35.5,35.5h202.8c21.3-1.8,33.2-13.6,35.5-35.5l-0.2-153.6c-2.2-18.2-13.7-29.7-34.4-34.5h-1V85.2                           c-4.3-26.8-16.3-48.5-35.8-65C187.8,8.6,166.3,1.9,137.9,0c-29.7,1.8-51.8,8.5-66.4,20.2C51.9,36.7,40,58.4,35.6,85.2v45.4h34.4                           V90c2.4-15.3,10.1-28.6,23-39.9c10.9-8.7,21.2-13.4,30.8-14.3C133.6,34.8,143.3,35.3,153.2,37.1 M163.4,277.4                           c0,7.5-2.6,13.8-7.8,19c-1.3,1.3-2.6,2.4-4.1,3.5l-0.5,6.5c0.1,0.9,0.2,1.8,0.2,2.8s-0.1,1.9-0.2,2.8c-0.5,2.9-1.9,5.5-4.1,7.7                           c-1,1-2,1.8-3,2.4c-2,1.2-4.4,1.8-7,1.9c-2.7-0.1-5-0.7-7-1.9c-1-0.7-2-1.5-3-2.4c-2.2-2.2-3.6-4.8-4.1-7.7                           c-0.2-0.9-0.2-1.8-0.2-2.8s0.1-1.9,0.2-2.8l-0.5-6.5c-1.4-1-2.8-2.2-4.1-3.5c-5.2-5.2-7.9-11.6-7.9-19c0-7.5,2.6-13.9,7.9-19.2                           c5.1-5.1,11.3-7.7,18.4-7.8h0.7c7.1,0.2,13.1,2.8,18.2,7.8C160.8,263.5,163.4,269.9,163.4,277.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.9650c892.svg";
export { ForwardRef as ReactComponent };